module.exports = __webpack_public_path__ + "static/media/logo-dark.60aeda6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-dark.svg
// module id = 73
// module chunks = 0